// extracted by css-extract-rspack-plugin
export default {"quantitySelect":"_7634d8a6"};